import React, { createContext } from 'react';
import { getFromAPI } from '../../../Utils/utils'; // Adjust the import path as needed

export const IncomeContext1 = createContext(null);
